var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"my-3"},[_c('ListHeader',{attrs:{"text":"配料選項","value":"items"}}),_c('ListTable',{attrs:{"value":"items","items":_vm.items,"fields":_vm.fields},on:{"remove":_vm.removeItem}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }